import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { StatusIndicator } from "@design-system/StatusIndicator/StatusIndicator";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    sendingDomainStatusLabel,
    sendingDomainStatusVariant,
} from "../sendingDomainHelpers";
import {
    isSuggestedSendingDomainRow,
    type SendingDomainRow,
} from "../sendingDomainsViewConfig";

export const StatusCell = memo(
    ({ row }: CellContext<ViewTableFeatures, SendingDomainRow, string>) => {
        if (isSuggestedSendingDomainRow(row.original)) {
            return <ViewTableCell />;
        }

        const { status, lastVerificationError } = row.original;
        return (
            <ViewTableCell>
                <StatusIndicator
                    appearance="solid"
                    variant={sendingDomainStatusVariant(status)}
                    label={sendingDomainStatusLabel(status)}
                    showText
                    tooltipLabel={lastVerificationError ?? undefined}
                />
            </ViewTableCell>
        );
    },
);
